import { HTMLAttributes, ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from '../../../../common/button-new';
import { Modal } from '../../../../common';
import { CvModalBaseProps } from './cv-modal-base.models';
import { useStyles } from './cv-modal-base.styles';
import { cx } from '../../../../../utils';

export const CvModalBase = ({
  image, imageText, title, text, onClose, onAction, button, buttonTestId, veevaNumber, ...props
}: CvModalBaseProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  const handleAction = async (): Promise<void> => {
    await onClose?.();
    onAction?.();
  };

  return (
    <Modal
      {...props}
      onClose={onClose}
      PaperProps={{
        'data-testid': 'cv-modal-base',
      } as HTMLAttributes<HTMLDivElement>}
      propsContentStyles={classes.content}
      propsPaperStyles={classes.paper}
      veevaNumber={veevaNumber}
      isVeevaSmall
      content={(
        <>
          <div
            className={classes.imageWrapper}
            data-testid="cv-image-wrapper"
          >
            {image && image}
            {imageText && <span className={classes.imageText}>{imageText}</span>}
          </div>
          {title && (
            <h2 className={cx('title-medium', classes.title)} data-testid="cv-title">
              {title}
            </h2>
          )}
          <p className={classes.description} data-testid="cv-description">
            {intl.formatMessage(
              { id: text },
              { sup: (chunks: ReactNode) => <sup>{chunks}</sup> },
            )}
          </p>
          {button && (
            <Button
              testId={buttonTestId}
              onClick={handleAction}
              style="cv"
            >
              <FormattedMessage id={button} />
            </Button>
          )}
        </>
      )}
    />
  );
};
